class TextColumnSlider extends HTMLElement {
  static observedAttributes = ['isslider'];

  constructor() {
    super();

    this.minDesktopWidth = DESKTOP_WIDTH || 1023;
    this.swiperInstance = null;
    this.resizeObserver = null;
    this.dataId = null;
    this.isMobileView = false;
    this.debounceTimeout = null;
  }

  connectedCallback() {
    this.dataId = this.getAttribute('data-id');
    this.isSlider = this.getAttribute('data-isslider');

    // Set up ResizeObserver to watch body width
    if (!this.resizeObserver) {
      this.observeBodyWidth();
    }

    this.handleResize(); // Initial check
  }

  //cleanup
  disconnectedCallback() {
    this.destroySwiper();

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  }

  //listen to attribute change
  attributeChangedCallback(name, oldValue, newValue) {
    if (name == 'isslider') {
      this.isSlider = newValue;
    }
  }

  debounceResize() {
    // Debounce to prevent multiple rapid calls
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      this.handleResize();
    }, 500); // 100ms debounce
  }

  observeBodyWidth() {
    this.resizeObserver = new ResizeObserver(() => {
      this.debounceResize();
    });

    // Start observing the body
    this.resizeObserver.observe(document.body);
  }

  handleResize() {
    const bodyWidth = document?.body?.offsetWidth;
    const isSlider = this.isMobileViewSlider();
    const currentViewMobile = bodyWidth < this.minDesktopWidth;

    if (currentViewMobile && isSlider) {
      this.isMobileView = true;
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  isMobileViewSlider() {
    return this.isSlider === 'slider';
  }

  initSwiper() {
    const swiperContainer = this.querySelector(
      `#text-column-slider-${this.dataId}`
    );

    const isSlider = this.isMobileViewSlider();

    if (!swiperContainer) {
      console.warn('Swiper container not found');

      return;
    }

    if (this.isMobileView && !this.swiperInstance && isSlider) {
      const paginationEnabled = {
        pagination: {
          el: `#swiper-pagination-${this.dataId}`,
          type: 'bullets',
          clickable: true,
        },
      };

      this.swiperInstance = new Swiper(swiperContainer, {
        ...paginationEnabled,
        speed: DEFAULT_SLIDER_SPEED,
        centeredSlides: false,
        loop: true,
        slidesPerView: 1,
        preventInteractionOnTransition: true,
      });
    } else {
      console.warn('Swiper.js is not loaded.');
    }
  }

  destroySwiper() {
    if (this.swiperInstance) {
      try {
        if (this.swiperInstance.destroyed) {
          console.info('Swiper already destroyed');

          this.swiperInstance = null;
          return;
        }
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      } catch (error) {
        console.error('Error destroying Swiper:', error);
        this.swiperInstance = null; // Fallback
      }
    } else {
      console.log('No Swiper instance to destroy');
    }
  }
}

customElements.define('text-column-slider-controller', TextColumnSlider);
